import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { MENU_ROUTES } from '../../utils/constants/routes';
import { useAuthStore } from '../../stores/authStore';

interface GuestGuardProps {
  children: ReactNode;
}

/**
 * GuestGuard component to render children if user is not authenticated
 * @param param Render children if user is not authenticated
 * @returns
 */
const GuestGuard = ({ children }: GuestGuardProps) => {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return <Navigate to={`/${MENU_ROUTES.HOME}`} replace />;
  }

  return <>{children}</>;
};

export default GuestGuard;
